import React, { useState, useEffect, useRef } from "react";
import styles from './Split.module.less';
export function Split({ left, right, initial = 50, onResize, vertical = false, className, children }) {
    const root = useRef(null);
    const resizer = useRef(null);
    const leftPane = useRef(null);
    const rightPane = useRef(null);
    const resizing = useRef(false);
    const [width, setWidth] = useState(initial);
    useEffect(() => {
        const onMove = ({ clientX, clientY }) => {
            if (resizing.current && root.current && leftPane.current && resizer.current) {
                const topRc = root.current.getBoundingClientRect();
                const leftRc = leftPane.current.getBoundingClientRect();
                setWidth(Math.max(0, Math.min(100, vertical ?
                    Math.min((clientY - leftRc.top), topRc.height - resizer.current.offsetHeight) / topRc.height * 100 :
                    Math.min((clientX - leftRc.left), topRc.width - resizer.current.offsetWidth) / topRc.width * 100)));
            }
        };
        const onUp = () => resizing.current = false;
        document.documentElement.addEventListener('mousemove', onMove);
        document.documentElement.addEventListener('mouseup', onUp);
        return () => {
            document.documentElement.removeEventListener('mousemove', onMove);
            document.documentElement.removeEventListener('mouseup', onUp);
        };
    }, []);
    useEffect(() => onResize?.(Math.round(width * 100) / 100), [width]);
    return (React.createElement("div", { className: `${styles.root} ${className ?? ''}`, ref: root, "data-vertical": vertical },
        React.createElement("div", { ref: leftPane, className: "left", style: { flexBasis: width + '%' } }, left),
        React.createElement("i", { className: "resizer", ref: resizer, onMouseDown: e => { e.stopPropagation(); resizing.current = true; }, onClick: e => e.stopPropagation() }, children),
        React.createElement("div", { ref: rightPane, className: "right" }, right)));
}
